/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from 'react';
import Navbar from 'react-bootstrap/Navbar';

import { useIsAuthenticated } from '@azure/msal-react';
import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <>
            <Navbar bg="primary" variant="dark" className="navbarStyle">
                <a className="navbar-brand" href="/">
                    Gibson (IPR)
                </a>
                {/* {isAuthenticated ? <SignOutButton /> : <SignInButton />} */}

                {/* <div className="collapse navbar-collapse justify-content-end">
                    {isAuthenticated ? <SignOutButton /> : <SignInButton />}
                </div> */}
            </Navbar>
                {/* <div className="title">
                    <h5>
                        Welcome to the Microsoft Authentication Library For JavaScript - React SPA
                    </h5>
                </div> */}
                <div className="profileContent">
                    {props.children}
                </div>
        </>
    );
};
